import React, { memo } from 'react';
import { BusinessCard } from './BusinessCard';

interface CardGridProps {
  results: any[];
  loading: boolean;
}

export const CardGrid: React.FC<CardGridProps> = memo(({ results, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="w-8 h-8 border-3 border-gray-300 border-t-blue-600 rounded-full animate-spin mx-auto mb-2"></div>
          <p className="text-gray-600">Searching...</p>
        </div>
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-gray-500">No results found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {results.map((item, index) => (
        <BusinessCard key={`${item._id || item.cid}-${index}`} item={item} />
      ))}
    </div>
  );
});

CardGrid.displayName = 'CardGrid';
